export default __webpack_public_path__ + "static/img6-414d992741fa21bec784853291686ea6.jpg";